// extracted by mini-css-extract-plugin
module.exports = {"container":"login_modal-module--container--1HG1Y","close":"login_modal-module--close--1PDHY","title":"login_modal-module--title--1ZqmH"};